import { render, staticRenderFns } from "./MultiPhotoLayout.vue?vue&type=template&id=0bed1dc2&"
import script from "./MultiPhotoLayout.vue?vue&type=script&lang=js&"
export * from "./MultiPhotoLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports